module.exports = __webpack_public_path__ + "static/media/bay.08a7463d.png";